import React from "react";
import Step from "components/MainApp/atoms/Wizard/Step";
import MainInput from "components/MainApp/atoms/Forms/MainInput";
import MainDropdownInput from "components/MainApp/atoms/Forms/MainDropdown";
import DescriptionForm from "../../../components/DescriptionForm";

import styles from "./Step1.module.scss";
import i18n from "i18n";

export class AddProviderStepOne extends React.Component {
  render() {
    const {
      provider,
      handleChange,
      handleSelect,
      handleContinue,
      countries,
      regions,
      provinces,
      cities,
      enableContinue,
      error,
    } = this.props;

    const stepContent = (
      <form onSubmit={handleContinue}>
        <div className={styles["add-provider-wizard-step-one-content"]}>
          <DescriptionForm
            provider={provider}
            handleChange={handleChange}
            handleSelect={handleSelect}
            countries={countries}
            regions={regions}
            provinces={provinces}
            cities={cities}
            error={error}
          />
          <div className={styles["add-provider-wizard-step-one-action-wrapper"]}>
            <button
              type="submit"
              className={`${styles["add-provider-wizard-step-one-action-button"]}${!enableContinue ? ` ${styles["disabled"]}` : ""}`}
              onClick={enableContinue ? handleContinue : undefined}
            >
              {i18n.t("continue").toUpperCase()}
            </button>
          </div>
        </div>
      </form>
    );

    return (
      <div className={styles["add-provider-wizard-step-one-container"]}>
        <Step title="" content={stepContent}></Step>
      </div>
    );
  }
}

export default AddProviderStepOne;
